export const M_SET_SEARCHED = "M_SET_SEARCHED";
export const M_SET_SEARCH_RESULT = "M_SET_SEARCH_RESULT";
export const M_SET_API_URL = "M_SET_API_URL";
export const M_SET_API_ORIGIN = "M_SET_API_ORIGIN";
export const M_SET_QUOTA_DESCRIPTION = "M_SET_QUOTA_DESCRIPTION";
export const M_SET_DATES_ISO = "M_SET_DATES_ISO";
export const M_SET_SHOW_QUOTAS = "M_SET_SHOW_QUOTAS";